import React, { useEffect, useState } from 'react'
import {
    FaChevronCircleDown,
    FaChevronCircleRight
} from 'react-icons/fa'
import office from "../assets/office.png"
import { api } from '../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import "./components.css"
import { useNavigate } from 'react-router-dom'

const Branch = ({ branch }) => {
    const [isOpened, setIsOpened] = useState(false)
    const [subBranches, setSubBranches] = useState([])
    const [title, setTitle] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [hasFetched, setHasFetched] = useState(false)

    const navigate = useNavigate()


    const handleToggle = async () => {
        setIsOpened(!isOpened)

        if (!hasFetched && !isOpened) {
            try {
                setIsLoading(true)
                const response = await api.get(`/${branch.name}/branches`)
                if (response?.data?.branches) {
                    setSubBranches(response.data.branches.organizations)
                    setTitle(response.data.branches.title)
                    setHasFetched(true)
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || "Error fetching sub-branches")
            } finally {
                setIsLoading(false)
            }
        }
    }

    return (
        <div className="branch-wrapper">
            <div className='branch-container'>
                <div className="open-branch-toggle" onClick={handleToggle}>
                    {isOpened ? <FaChevronCircleDown /> : <FaChevronCircleRight />}
                </div>
                <div className="org-branch-logo">
                    <img src={branch.profilePic || office} alt="" />
                </div>
                <div className="org-branch-details" onClick={()=>navigate(`/${branch.name}`)}>
                    <h4 className="branch-name">{branch.name} {branch.titles}</h4>
                    <p className='branch-title'>{title}</p>
                    <div className="branch-comm">
                        <p>{branch.members}</p>
                        <p>{branch.friends}</p>
                    </div>
                </div>
            </div>

            {/* Sub-branches */}
            {isOpened && (
                <div className="sub-branches">
                    {isLoading ? (
                        <p>Loading...</p>
                    ) : (
                        subBranches?.map((b) => <Branch key={b.id || b.name} branch={b} />)
                    )}
                </div>
            )}
        </div>
    )
}

export default Branch
